// Reads the &isProctoringEnabled=true|false flag that the candidate-test app
// appends to the language-test URL and remembers it for the whole session.
//
// - The value is a string ("true" / "false"); anything other than the exact
//   string "false" (including a missing param) means proctored.
// - It is persisted to sessionStorage so it survives in-app navigation and the
//   URL cleanup that languageTest.js performs on load.

const STORAGE_KEY = "LANGUAGE_TEST_PROCTORING_ENABLED";

const readStored = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

const writeStored = (enabled) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, enabled ? "true" : "false");
  } catch (e) {
    /* sessionStorage unavailable — fall back to default on next read */
  }
};

// Call once on load (before the URL is cleaned). Reads the param if present,
// otherwise falls back to whatever was stored earlier this session, otherwise
// defaults to proctored.
export const resolveProctoringEnabled = () => {
  const params = new URLSearchParams(window.location.search);
  const rawParam = params.get("isProctoringEnabled");
  const stored = readStored();

  let result;
  let source;

  if (params.has("isProctoringEnabled")) {
    result = rawParam !== "false";
    source = "url-param";
    writeStored(result);
  } else if (stored !== null) {
    result = stored !== "false";
    source = "sessionStorage";
  } else {
    result = true;
    source = "default";
  }

  console.log("[proctoring] resolveProctoringEnabled", {
    href: window.location.href,
    search: window.location.search,
    rawParam,
    hasParam: params.has("isProctoringEnabled"),
    storedValue: stored,
    source,
    isProctoringEnabled: result,
  });

  return result;
};

// Cheap read for anywhere else that needs the flag after it has been resolved.
export const isProctoringEnabled = () => {
  const stored = readStored();
  if (stored !== null) return stored !== "false";
  return true;
};
